import { render } from "./KYCPage.vue?vue&type=template&id=44e45806&scoped=true"
import script from "./KYCPage.vue?vue&type=script&lang=js"
export * from "./KYCPage.vue?vue&type=script&lang=js"

import "./KYCPage.vue?vue&type=style&index=0&id=44e45806&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e45806"]])

export default __exports__